import type { Reducer } from 'redux';

import type { BaseTaskTodo, TaskTodoListOptions } from 'models';

import type { ActionTypes } from 'store/helpers';
import { getDatesByDateFilter } from 'containers/pages/todo/helpers';
import { DateRangeType } from 'shared/constants';

import { TodoActionTypes } from './action-types';

export interface TodoState {
  coopId: string | null;
  todoList: BaseTaskTodo[];
  upload: boolean;
  options: TaskTodoListOptions;
  startDate: Date | null;
  endDate: Date | null;
  dateFilter: DateRangeType;
  searchTerm: string;
  loading: boolean;
  error: boolean;
}

const DEFAULT_DATE_FILTER = DateRangeType.ThisYear;

const initialState: TodoState = {
  coopId: null,
  loading: true,
  upload: false,
  error: false,
  dateFilter: DEFAULT_DATE_FILTER,
  ...getDatesByDateFilter(DEFAULT_DATE_FILTER),
  todoList: [],
  options: {
    CanCreate: false,
    Sort: [],
    Status: [],
  },
  searchTerm: '',
};

export const reducer: Reducer<TodoState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TodoActionTypes.REQUEST_TODO_RESOURCES:
      return {
        ...state,
        upload: false,
        loading: true,
        error: false,
        coopId: action.payload,
        todoList: [],
        options: {
          CanCreate: false,
          Sort: [],
          Status: [],
        },
      };
    case TodoActionTypes.REQUEST_TODO_RESOURCES_SUCCESS:
      return {
        ...state,
        loading: false,
        todoList: action.payload.tasks,
        options: action.payload.options,
      };
    case TodoActionTypes.REQUEST_TODO_RESOURCES_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case TodoActionTypes.REQUEST_TODO_LIST:
      return {
        ...state,
        upload: true,
      };
    case TodoActionTypes.REQUEST_TODO_LIST_SUCCESS:
      return {
        ...state,
        todoList: action.payload,
        upload: false,
      };
    case TodoActionTypes.REQUEST_TODO_LIST_FAILED:
      return {
        ...state,
        upload: false,
        error: true,
      };
    case TodoActionTypes.SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
      };
    case TodoActionTypes.SET_START_DATE:
      return {
        ...state,
        startDate: action.payload,
      };
    case TodoActionTypes.SET_END_DATE:
      return {
        ...state,
        endDate: action.payload,
      };
    case TodoActionTypes.SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload,
      };
    default:
      return state;
  }
};
